module.exports = __webpack_public_path__ + "img/horizontal_4_7_r_pp3_7005.8479286c.png";